import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-5c0 -6.075 4.925 -11 11 -11h5","key":"svg-0"}]]

const IconBorderCornerPill = createReactComponent('outline', 'border-corner-pill', 'BorderCornerPill', __iconNode);

export default IconBorderCornerPill;